import type { ComputePosition, Coords } from './types';

export const computePosition: ComputePosition = async (
  reference,
  floating,
  offset,
  bindToBody,
): Promise<Coords> => {
  const { innerWidth, innerHeight } = window;
  const float = floating.getBoundingClientRect();

  if (bindToBody) {
    return {
      x: (innerWidth - float.width) / 2,
      y: (innerHeight - float.height) / 2,
    };
  }

  const [oX, oY] = offset || [0, 0];
  const ref = reference.getBoundingClientRect();

  const horizontal = ref.x + oX + float.width < innerWidth;
  const vertical = ref.y + oY + float.height < innerHeight;

  const left = ref.x + oX;
  const right = ref.x + ref.width - float.width - oX;
  const bottom = ref.y + ref.height + oY;
  const top = ref.y - float.height - oY;

  return {
    x: horizontal ? left : right,
    y: vertical ? bottom : top,
  };
};
